import * as Yup from 'yup';

export const buildWebhookConfigSchema = () =>
  Yup.object({
    url: Yup.string()
      .url('Must be a valid URL')
      .matches(/https:\/\/.*$/, 'URL must start with https://')
      .required('URL is required'),
  });
